import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Callout } from 'seagull';
import { AnchorLogo } from 'seagull/icons';
import { useIoContext } from "../../../contexts";
import { useSetDocumentTitle } from "../../../hooks/useSetDocumentTitle";
import { FormTitle } from "../components/FormComponents";
import UnauthorizedPageContainer from "../components/UnauthorizedPageContainer";
import styles from "./LoginScreen.module.scss";
import { LoginFlow } from "./LoginScreen.types";
import { getIsSimplifiedLogin, getTheNextStep } from "./LoginScreen.utils";
import EmailStep from "./Steps/Email";
import OTPForm from "./Steps/OTPForm";
import PasswordStep from "./Steps/Password";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function getClientViewURL(pathname) {
  return "".concat(pathname, "?view=client");
}
export function LoginScreen() {
  const location = useLocation();
  const locationState = location.state;
  const [currentStep, setCurrentStep] = useState({
    step: LoginFlow.Email
  });
  const {
    cookies
  } = useIoContext();
  const hasVendorAccount = cookies.getHasVendorAccountFromUserDetailsCookie();
  const isSimplifiedLogin = getIsSimplifiedLogin({
    setLoginFlow: locationState === null || locationState === void 0 ? void 0 : locationState.setLoginFlow,
    locationSearch: location.search,
    hasVendorAccount: hasVendorAccount !== null && hasVendorAccount !== void 0 ? hasVendorAccount : undefined
  });
  useSetDocumentTitle('Anchor Login');
  function getTitleMP() {
    return /*#__PURE__*/_jsx(FormTitle, {
      children: isSimplifiedLogin ? /*#__PURE__*/_jsx(AnchorLogo, {
        className: styles.logo
      }) : 'Welcome to Anchor'
    });
  }
  return /*#__PURE__*/_jsxs(UnauthorizedPageContainer, {
    animatedBackground: !isSimplifiedLogin,
    hideBanner: isSimplifiedLogin,
    testId: "login-form",
    otpLayout: currentStep.step === LoginFlow.OTP || currentStep.step === LoginFlow.EmailVerification,
    children: [currentStep.step === LoginFlow.Email && /*#__PURE__*/_jsx(EmailStep, {
      onSubmit: _ref => {
        let {
          email,
          flow
        } = _ref;
        setCurrentStep({
          step: getTheNextStep({
            flow,
            isSimplifiedLogin
          }),
          email
        });
      },
      titleMP: getTitleMP(),
      subtitleMP: isSimplifiedLogin ? /*#__PURE__*/_jsx(FormTitle, {
        children: isSimplifiedLogin ? 'Welcome to Anchor' : 'Login to continue'
      }) : locationState !== null && locationState !== void 0 && locationState.sessionTimeout ? /*#__PURE__*/_jsx(Callout, {
        hideIcon: true,
        intent: "error",
        testId: "session-timeout-error",
        children: "You have been automatically signed out due to inactivity."
      }) : null,
      simplified: isSimplifiedLogin,
      emailFromState: locationState === null || locationState === void 0 ? void 0 : locationState.recipientEmail
    }), currentStep.step === LoginFlow.Password && /*#__PURE__*/_jsx(PasswordStep, {
      email: currentStep.email,
      onClickRequestOTP: () => {
        setCurrentStep({
          step: LoginFlow.OTP,
          email: currentStep.email
        });
      },
      titleMP: getTitleMP(),
      subtitleMP: isSimplifiedLogin ? /*#__PURE__*/_jsx(FormTitle, {
        children: "Login to continue"
      }) : null
    }), currentStep.step === LoginFlow.OTP && /*#__PURE__*/_jsx(OTPForm, {
      email: currentStep.email,
      flow: LoginFlow.OTP,
      onBack: () => setCurrentStep({
        step: LoginFlow.Email
      }),
      shouldRequestOTP: true
    }), currentStep.step === LoginFlow.EmailVerification && /*#__PURE__*/_jsx(OTPForm, {
      email: currentStep.email,
      flow: LoginFlow.EmailVerification,
      onBack: () => setCurrentStep({
        step: LoginFlow.Email
      }),
      shouldRequestOTP: true
    })]
  });
}